<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4"></div>

      <div class="col-lg-4">
        <div class="card">
          <p class="title">Data wijzigen</p>

          <div class="edit-profile-form">
            <div class="form-group">
              <h3>Voornaam</h3>
              <input id="profile-firstname-field" type="text" class="form-control" v-model="firstName"
                     placeholder="Voornaam">
            </div>
            <div class="form-group">
              <h3>Achternaam</h3>
              <input id="profile-lastname-field" type="text" class="form-control" v-model="lastName"
                     placeholder="Achternaam">
            </div>

            <div class="form-group">
              <h3>Email</h3>
              <input id="profile-email-field" type="text" class="form-control" :value="initialEmail" placeholder="email"
                     disabled>
            </div>

            <v-button class="save-changes-button" buttonText="Data wijzigen" v-on:clicked="updateProfile"
                      :enabled="true"></v-button>
            <a class="cancel-button" href="#" v-on:click.prevent="cancelClicked">Annuleren</a>

          </div>
        </div>
      </div>

      <div class="col-lg-4"></div>

    </div>
  </div>
</template>

<script>
import VButton from "@/components/UI/VButton";
import log from "@/utils/logger";
import { UserApi } from "sandpiper_api";
import AuthMixin from "@/mixins/AuthMixin";

export default {
  name: "EditProfile",
  components: { VButton },
  mixins: [ AuthMixin ],
  inject: [ "doApiRequest" ],
  props: {
    initialFirstName: String,
    initialLastName: String,
    initialEmail: String,
  },
  data()
  {
    return {
      updatingProfile: false,
      firstName: "",
      lastName: ""
    }
  },
  methods: {
    cancelClicked()
    {
      this.$router.push({ name: "profile" });
    },
    async updateProfile()
    {
      try
      {
        log.info("Updating user profile");
        this.updatingProfile = true;
        // await this.doApiRequest(() => new UserApi().putUserProfile(this.getCurrentJwtInfo().payload.userId, {
        await this.doApiRequest(() => new UserApi().putUserProfile(this.currentUserId, {
          UserProfile: {
            firstName: this.firstName,
            lastName: this.lastName
          }
        }));

        await this.$router.push({ name: "profile" });
      }
      catch (e)
      {
        // TODO - handle error
        log.error("Failed to fetch profile - %o", e);
      }
      finally
      {
        this.updatingProfile = false;
      }
    }
  },
  created()
  {
    this.firstName = this.initialFirstName;
    this.lastName = this.initialLastName;
  }
}
</script>

<style lang="scss" scoped>

.agenda-cards
{
  align-items: flex-start;
}

.card
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;

  .title
  {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle
  {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.save-changes-button
{
  margin-bottom: 25px;
}

.cancel-button
{
  align-self: center;
}

.edit-profile-form
{
  margin-top: 25px;
  display: flex;
  flex-direction: column;
}
</style>